/** Inbox draft-replies onboarding tour (mounted as `inbox.tour`). */
export const enInboxTour = {
	draftCardTitle: "AI Draft Replies",
	draftCardContent:
		"These are AI-generated draft replies based on the conversation context. Click on a card to preview and edit it before sending.",
	draftEditorTitle: "Reply Editor",
	draftEditorContent:
		"Edit the selected draft reply here or write your own message. Press Cmd+Enter (or Ctrl+Enter) to send.",
	draftSettingsNavTitle: "Configure Draft Replies",
	draftSettingsNavContent:
		'Click "Got it" to go to your Company Settings where you can change how many AI draft replies are generated — or disable them entirely.',
	draftSettingsTitle: "Draft Replies Setting",
	draftSettingsContent:
		"Use this dropdown to change how many AI draft replies are generated — or disable them entirely.",
};
